const BG_SUCCESS_FLAGS = ['Well constructed'];

export const ProblemFlagBadge = ({
    type,
    number,
}: {
    type: string;
    number: number;
}) => {
    let badgeClass = 'bg-danger';
    if (BG_SUCCESS_FLAGS.includes(type)) {
        badgeClass = 'bg-success';
    }

    return (
        <span className={`mr-2 badge ${badgeClass}`}>
            {number} × {type}
        </span>
    );
};
